import { useEffect, useState } from 'react';

// v1.3.37.140 — same query as the Tailwind `phoneland` screen.
export const PHONE_LANDSCAPE_QUERY = '(orientation: landscape) and (max-height: 500px)';

const read = () =>
  typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(PHONE_LANDSCAPE_QUERY).matches;

/** True while a phone is held sideways; re-evaluates on rotation/resize. */
export function usePhoneLandscape() {
  const [isLand, setIsLand] = useState(read);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(PHONE_LANDSCAPE_QUERY);
    const onChange = () => setIsLand(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener(onChange);
    window.addEventListener('orientationchange', onChange);
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', onChange) : mq.removeListener(onChange);
      window.removeEventListener('orientationchange', onChange);
    };
  }, []);
  useEffect(() => {
    document.documentElement.dataset.orientation = isLand ? 'phone-landscape' : 'default';
  }, [isLand]);
  return isLand;
}
